import { InitWithPikadoClient, UserService } from '@PikaDoApp/npm-pikado-logic';
import { getEnvironment } from './getEnvironment';
import { store } from '../redux/store';
import { doSignOut } from '../redux/actions/user';

export function initializePikadoClient() {
  InitWithPikadoClient({
    environment: getEnvironment(),
    getAccessToken: () => localStorage.getItem('accessToken'),
    getRefreshToken: () => localStorage.getItem('refreshToken'),
    refreshAccessToken: async (refreshToken) => {
      try {
        const userService = new UserService();
        const refreshRes = await userService.refreshToken({ refreshToken });
        localStorage.setItem('accessToken', refreshRes.token);
        localStorage.setItem('refreshToken', refreshRes.refreshToken);
        return refreshRes.token;
      } catch (error) {
        console.error('Failed to refresh accessToken:', error);
        // Automatically logout on refresh failure
        store.dispatch(doSignOut() as any);
        throw error;
      }
    },
    onUnauthorized: () => {
      store.dispatch(doSignOut() as any);
    }
  });
}
